import styled from 'styled-components';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { RouterLink } from '@redux-first-router-link';

export const HorizontalRule = styled('hr')`
  height: 1px;
  background-color: ${(props) => props.theme.color.whiteRGBA(0.1)};
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const Question = styled('p')`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.whiteRGBA(0.5)};
  margin: 0;
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;

export const Link = styled(RouterLink)`
  ${(props) => props.theme.typography.smallStrong}
  color: ${(props) => props.theme.color.brand01};
`;

export const ChevronRightIcon = styled(ChevronRightSmallSolid)`
  ${(props) => props.theme.typography.smallStrong}
  height: 1.5em;
  width: 1.5em;
  margin-bottom: -0.25em;
  vertical-align: bottom;
  path {
    fill: ${({ theme }) => theme.color.brand01};
  }
`;

export const Term = styled('span')`
  white-space: nowrap;
  color: inherit;
  border-bottom: 1px dotted ${({ theme }) => theme.color.brand01};
  cursor: help;
  display: inline-block;
`;

export const TooltipTitle = styled('p')`
  margin: 0;
  max-width: 200px;
  ${({ theme }) => theme.typography.tiny};
`;
